import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['categorySelect', 'panel', 'fields']
  static values = {
    slugMap: Object,
    fields: Object
  }

  connect () {
    this.render()
  }

  categoryChanged () {
    this.render()
  }

  render () {
    if (!this.hasCategorySelectTarget || !this.hasPanelTarget || !this.hasFieldsTarget) return

    const categoryId = this.categorySelectTarget.value
    const slug = this.slugMapValue[categoryId] || 'general'
    const fields = this.fieldsValue[slug] || this.fieldsValue.general || []
    const saved = this.readSavedValues()

    if (fields.length === 0) {
      this.panelTarget.classList.add('hidden')
      this.fieldsTarget.innerHTML = ''
      return
    }

    this.panelTarget.classList.remove('hidden')
    this.fieldsTarget.innerHTML = fields.map((field) => this.fieldHtml(field, saved[field.key])).join('')
  }

  readSavedValues () {
    try {
      return JSON.parse(this.element.dataset.savedConditionDetails || '{}')
    } catch (_e) {
      return {}
    }
  }

  fieldHtml (field, savedValue) {
    const name = `marketplace_ad[condition_details][${field.key}]`
    const required = field.required ? 'required' : ''
    const inputClass =
      'mt-2 w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm shadow-inner outline-none transition placeholder:text-slate-400 focus:border-amber-400 focus:ring-2 focus:ring-amber-100'

    let control = ''
    if (field.type === 'select') {
      const options = (field.options || [])
        .map(([label, value]) => {
          const selected = savedValue === value ? 'selected' : ''
          return `<option value="${value}" ${selected}>${label}</option>`
        })
        .join('')
      control = `<select name="${name}" class="${inputClass}" ${required}><option value="">Select</option>${options}</select>`
    } else if (field.type === 'imei') {
      control = `<input type="text" name="${name}" value="${savedValue || ''}" inputmode="numeric" pattern="[0-9]{15}" maxlength="15" placeholder="356789012345678" class="${inputClass} font-mono tracking-wide" ${required} />`
    } else {
      control = `<input type="text" name="${name}" value="${savedValue || ''}" class="${inputClass}" ${required} />`
    }

    const hint = field.hint ? `<p class="mt-1.5 text-xs text-slate-400">${field.hint}</p>` : ''

    return `
      <div class="${field.type === 'imei' ? 'sm:col-span-2' : ''}">
        <label class="block text-sm font-semibold text-slate-700">${field.label}${field.required ? ' <span class="text-rose-500">*</span>' : ''}</label>
        ${control}
        ${hint}
      </div>
    `
  }
}
